<template>
  <div class="vx-row min-h-screen">
    <div class="vx-col w-full">
      <header-public></header-public>
    </div>
    <div class="vx-col w-full">
      <div
        v-if="dish.images[0]"
        class="container w-full max-w-5xl mx-auto bg-white bg-center bg-cover bg-no-repeat md:rounded"
        :style="{
          'background-image': 'url(' + dish.images[0].path + ')',
          height: '48vh',
          position: 'relative',
          zIndex: '1',
        }"
      ></div>
      <div
        class="container max-w-4xl mx-auto mb-8"
        :class="{ '-mt-48': dish.images[0], 'mt-8': !dish.images[0] }"
        style="position: relative; z-index: 2"
      >
        <div class="bg-white p-6 md:p-8 text-gray-800 leading-normal shadow-md rounded-lg text-justify relative">
          <h1 class="font-bold break-normal text-2xl mb-1">{{ dish.name }}</h1>
          <span class="precio px-5 py-2 rounded-lg bg-petrol text-white text-lg font-bold sans-serif"
            >{{ dish.price.toFixed(2) }}€</span
          >
          <router-link
            :to="{ name: 'publicRestaurant', params: { id: dish.restaurant_id, lang: language } }"
            class="text-petrol font-bold"
          >
            {{ restaurant.name }}<font-awesome-icon :icon="['fas', 'chevron-right']" class="ml-2" />
          </router-link>
          <div class="tags mt-4 float-none">
            <span class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light float-left text-sm" v-for="tag in dish.tags">{{
              tag.name
            }}</span>
          </div>

          <span class="clearfix"></span>

          <div class="desc float-none clearfix mt-2 mb-4">
            <div class="mb-2" v-if="dish.description">
              <p>{{ dish.description }}</p>
            </div>
            <p class="mt-4">{{ dish.size }}</p>
          </div>
          <vs-tabs :color="colorx">
            <vs-tab
              :label="$t('Ingredientes')"
              v-if="ingredients.length > 1 || (ingredients.length == 1 && ingredients[0] !== null)"
            >
              <div class="p-4">
                <ul class="list-none">
                  <li v-for="ingredient in ingredients">{{ ingredient }}</li>
                </ul>
              </div>
            </vs-tab>
            <vs-tab :label="$t('Alergenos')" v-if="dish.allergens.length > 0">
              <div class="p-4">
                <div class="flex flex-wrap text-center">
                  <div class="w-1/4 md:w-1/12 mx-3 mb-2" v-for="allergen in dish.allergens">
                    <img class="w-full" :src="allergen.image_path" />
                    <p class="self-center text-xs mt-2">{{ allergen.name }}</p>
                  </div>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
          <p v-if="dish.allergens.length == 0">{{ $t('SinAlergenos') }}</p>
          <div class="rounded-lg flex shadow p-2 flex mt-6" v-if="restaurant.terrace_supplement">
            <div class="w-1/12 inline-flex">
              <img src="/logo_min.png" class="w-8" />
            </div>
            <div class="w-11/12 text-sm font-bold text-center content-center self-center">
              {{ $t('public.PrecioTerraza', { precio: restaurant.terrace_supplement.toFixed(2) }) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full self-end" style="position: relative; z-index: 2">
      <footer-public :restaurant="restaurant"></footer-public>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HeaderPublic from '../Public/Header';
import FooterPublic from '../Public/Footer';

export default {
  components: {
    FooterPublic,
    HeaderPublic,
  },
  props: {
    dish: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      colorx: 'secondary',
    };
  },
  created () {
    this.getRestaurantPublic({ slug: this.dish.slug_restaurant, language: this.language });
  },
  computed: {
    ...mapGetters({
      restaurant: 'getRestaurant',
      language: 'getCurrentLanguagePublic',
    }),
    ingredients () {
      return this.dish.ingredients;
    },
  },
  methods: {
    ...mapActions({
      getRestaurantPublic: 'getRestaurantPublic',
    }),
  },
};
</script>
